/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react'
import RequestInterceptor from './middlewares/RequestInterceptor'
import { getCurrentAccount } from './actions'
import { routes } from './constants'
import { SignedOut, HeaderMenu } from './components'
import { checkErrorResponse, Logger, LoggerTypes } from './utils'
import './components/icons/fontello/css/fontello.css'
import './App.scss'
import { clearStorage, getUserInfosFromStorage, setUserInfosToStorage } from './storage/storage'
import { AccountProvider } from './contexts'
import { SplashLoadingForm } from './components/forms/SplashLoadingForm'

const routePages = []
Object.values(routes).forEach((route, i) => {
  routePages.push(<Route key={`route-${i}`} {...route} />)
})

const SignedIn = () => {
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const projects = useSelector((_state) => _state.projects) || null
  const scenarios = useSelector((_state) => _state.scenarios) || null
  const currentProject = (projects && projects.currentProject) || null
  const currentScenario = (scenarios && scenarios.currentScenario) || null

  const [userInfos, setUserInfos] = useState(getUserInfosFromStorage() || null)

  Logger.trace(LoggerTypes.INIT, 'App.render()', {
    routes,
    currentProject,
    currentScenario
  })

  useEffect(() => {
    Logger.trace(LoggerTypes.CONTROLLER, 'Page.useEffect(). - User Infos getCurrentAccount()', { userInfos })

    if (userInfos === null) {
      dispatch(getCurrentAccount())
        .then((res) => {
          Logger.trace(LoggerTypes.CONTROLLER, 'Page.useEffect().dispatch(getCurrentAccount()).then()', { res })
          setUserInfosToStorage(res.data)
          setUserInfos(res.data)
        })
        .catch((res) => {
          Logger.trace(LoggerTypes.WARN, 'Page.useEffect().dispatch(getCurrentAccount()).catch()', { res })
          checkErrorResponse(res, enqueueSnackbar, t)
        })
    }
  }, [])

  return userInfos?.permissions ? (
    <AccountProvider value={userInfos.permissions}>
      <Router>
        <HeaderMenu currentProject={currentProject} currentScenario={currentScenario} />
        <Routes>{routePages}</Routes>
      </Router>
    </AccountProvider>
  ) : (
    <SplashLoadingForm topMessage={t('common.loading.rights')}></SplashLoadingForm>
  )
}

const onRefreshTokenExpired = () => {
  Logger.trace(LoggerTypes.CONTROLLER, 'Refresh token is expired!')
  clearStorage()
}

const App = () => {
  return (
    <div className="App">
      <AuthenticatedTemplate>
        <RequestInterceptor expiredTokenCallback={onRefreshTokenExpired}>
          <SignedIn />
        </RequestInterceptor>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <SignedOut />
      </UnauthenticatedTemplate>
    </div>
  )
}

// App.propTypes = {
//   props: PropTypes.any
// }

// const mapStateToProps = ({ data = {}, isLoading = false }) => ({
//   data,
//   isLoading
// })

// export default connect(mapStateToProps, {})(App)
export default App
